module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-08.d2d56f19.jpg";